<div id="landing-v2">
  <app-hero-v2></app-hero-v2>
  <app-statistics-v2></app-statistics-v2>
  <app-solutions-v2></app-solutions-v2>
  <app-our-services-v2></app-our-services-v2>
</div>
